// Centralized query keys for React Query
// Following the factory pattern for type-safe and composable query keys

export const queryKeys = {
  // Tasks
  tasks: {
    all: ["tasks"] as const,
    lists: () => [...queryKeys.tasks.all, "list"] as const,
    list: (filters: Record<string, unknown>) => [...queryKeys.tasks.lists(), filters] as const,
    details: () => [...queryKeys.tasks.all, "detail"] as const,
    detail: (id: string) => [...queryKeys.tasks.details(), id] as const,
    images: (id: string) => [...queryKeys.tasks.all, "images", id] as const,
  },

  // Categories
  categories: {
    all: ["categories"] as const,
    lists: () => [...queryKeys.categories.all, "list"] as const,
  },

  // Document Types
  documentTypes: {
    all: ["documentTypes"] as const,
    lists: () => [...queryKeys.documentTypes.all, "list"] as const,
  },

  // Formulas
  formulas: {
    all: ["formulas"] as const,
    lists: () => [...queryKeys.formulas.all, "list"] as const,
  },

  // Blog posts (for future use)
  blogPosts: {
    all: ["blogPosts"] as const,
    lists: () => [...queryKeys.blogPosts.all, "list"] as const,
    detail: (slug: string) => [...queryKeys.blogPosts.all, "detail", slug] as const,
  },
} as const;

// Cache configuration
export const cacheConfig = {
  // Tasks - moderate cache since they can be updated frequently in admin
  tasks: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
  },

  // Metadata - longer cache since they change less frequently
  metadata: {
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
  },

  // Blog posts - shorter cache for content freshness
  blogPosts: {
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 15 * 60 * 1000, // 15 minutes
  },
} as const;
